import React, { useState, useMemo, useEffect } from 'react';
import { ModalBody, ConfirmationPageModal, HoverAnimationBtn } from './styles';
import { useTranslation } from 'react-i18next';
import { CONFIRMATION_PAGE_MODAL } from './translationValues';
import { withTranslation } from 'react-i18next';
import {
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
  useDocumentContext,
} from '../../context/complexDocumentContext';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { v4 as uuidv4 } from 'uuid';
import { TocSettings } from '../../artboard/TableOfContents/styles';
import { TOC_SIDEBAR } from '../../artboard/TableOfContents/translationValues';
import { Input, Radio, Switch, Typography, message } from 'antd';

const NAMESPACES = ['CONFIRMATION_PAGE_MODAL'];

const AddToTocModal = () => {
  const { t } = useTranslation(NAMESPACES);

  const [, methods] = useDocumentContext(() => null, 'addToTocModal');

  const [editorRef, updateArtboard] = useArtboardContext(
    store => store[CONTEXT_KEYS.TEXT_ELEMENT_REF],
  );

  const [tocInfo] = useArtboardContext(store => store[CONTEXT_KEYS.TOC_MODAL_INFO]);

  const editor = editorRef?.current?.getEditor();
  const selectedText = tocInfo?.selectedText;
  const [textSelected, setTextSelected] = useState('');
  const newToc = {
    isHeading: false,
    elementId: uuidv4(),
    particular: '',
    addToc: false,
    level: null,
  };
  const [tocHeading, setTocHeading] = useState(newToc);
  const currentSelection = useMemo(() => editor?.getSelection(true), [selectedText]);

  useEffect(() => {
    const editor = editorRef?.current?.getEditor();
    if (editor) {
      const range = editor.getSelection();
      if (range && range.length > 0) {
        const selectedQuillText = editor.getText(range.index, range.length);
        setTextSelected(selectedQuillText);
        const updatedHeadingObject = { ...tocHeading, particular: selectedQuillText };
        const headingFormat = editor.getFormat(range).heading;
        let obj = Array.isArray(headingFormat) ? headingFormat[0] : headingFormat;
        if (!obj) {
          obj = { ...newToc, particular: selectedQuillText };
        }
        if (obj && !('addToc' in obj)) {
          const delta = editor.getContents();
          const parentElement = delta.ops.find(item => {
            const heading = item.attributes?.heading;
            return heading?.elementId === obj.elementId && 'addToc' in heading;
          });
          obj = parentElement?.attributes?.heading || obj;
        }
        setTocHeading(obj ? { ...updatedHeadingObject, ...obj } : updatedHeadingObject);
      } else {
        setTextSelected('');
        setTocHeading({
          isHeading: false,
          elementId: uuidv4(),
          particular: '',
          addToc: false,
        });
      }
    }
  }, [editorRef, selectedText]);

  const scrollToPosition = () => {
    const bounds = editor.getBounds(currentSelection);
      const editorContainer = editor.scrollingContainer.closest('.vertical-layout')
      if (editorContainer) {
        editorContainer.scrollTop = bounds.top;
      }
  }

  const onChangeText_Level = e => {
    scrollToPosition();
    const name = e?.target?.name;
    const value = name === 'level' ? Number(e?.target?.value) : e?.target?.value;

    let updatedData;
    if (name === 'level' && tocHeading.level === value) {
      updatedData = { ...tocHeading, [name]: null };
    } else {
      updatedData = { ...tocHeading, [name]: value };
    }
    setTocHeading(updatedData);
  };

  const onChangeSwitch = checked => {
    let updatedData;
    if (!tocHeading?.particular || tocHeading.particular.length === 0) {
      updatedData = { ...tocHeading, particular: textSelected, addToc: checked };
    } else if (!tocHeading?.level) {
      updatedData = { ...tocHeading, level: 1, addToc: checked };
    } else {
      updatedData = { ...tocHeading, addToc: checked };
    }
    setTocHeading(updatedData);
    scrollToPosition();
  };

  const updateHeading = updatedData => {
    const range = currentSelection;
    const delta = editor.getContents(range);
    const ops = delta.ops;
    if (ops.length > 0) {
      if (ops[0].attributes?.heading?.elementId) {
        const deltaa = editor.getContents();
        let tempIndex = 0;
        let calculatedIndex = -1;
        const parentElement = deltaa.ops.find(item => {
          const heading = item.attributes?.heading;
          return heading?.elementId === ops[0].attributes?.heading.elementId && 'addToc' in heading;
        });
        for (var i = 0; i < deltaa.ops.length; i++) {
          let op = deltaa.ops[i];
          if (op.insert) {
            var insertedText = op.insert;
            if (typeof insertedText === 'string') {
              var foundIndex = insertedText.indexOf(parentElement.insert);
              if (
                foundIndex !== -1 &&
                op.attributes?.heading?.elementId === ops[0].attributes?.heading.elementId
              ) {
                calculatedIndex = tempIndex + foundIndex;
                break;
              }
              tempIndex += insertedText.length;
            } else {
              tempIndex += 1;
            }
          }
        }
        if (calculatedIndex !== -1) {
          var parentElementInsertLength = parentElement.insert.length;
          var startIndex = calculatedIndex;
          editor.formatText(startIndex, parentElementInsertLength, 'heading', updatedData, 'user');
        }
      } else {
        const firstOp = ops[0];
        editor.formatText(range.index, firstOp.insert.length, 'heading', updatedData, 'user');
        for (let i = 1; i < ops.length; i++) {
          const op = ops[i];
          editor.formatText(
            range.index + ops.slice(0, i).reduce((sum, op) => sum + (op.insert || '').length, 0),
            (op.insert || '').length,
            'heading',
            { elementId: updatedData.elementId },
            'user',
          );
        }
      }
    }
    editor.setSelection(currentSelection);
    methods.set({ [COMPLEX_DOCUMENT_CONTEXT_KEYS.AUTOSAVE_CALLBACK]: responseMessage });
    updateArtboard({ [CONTEXT_KEYS.TOC_MODAL_INFO]: undefined });
    scrollToPosition();
  };

  const responseMessage = status => {
    console.log('status==>', status);
    status
      ? message.success(
          t(
            CONFIRMATION_PAGE_MODAL.TOC_SETTINGS_SUCCESS_MESSAGE.key,
            CONFIRMATION_PAGE_MODAL.TOC_SETTINGS_SUCCESS_MESSAGE.value,
          ),
        )
      : message.error(
          t(
            CONFIRMATION_PAGE_MODAL.TOC_SETTINGS_ERROR_MESSAGE.key,
            CONFIRMATION_PAGE_MODAL.TOC_SETTINGS_ERROR_MESSAGE.value,
          ),
        );
  }

  let visible = tocInfo ? Object.keys(tocInfo).length > 0 : false;

  const onCancel = () => {
    scrollToPosition();
    updateArtboard({ [CONTEXT_KEYS.TOC_MODAL_INFO]: undefined });
  };

  if (!visible) return <div />;

  return (
    <ConfirmationPageModal
      title={t(
        CONFIRMATION_PAGE_MODAL.TOC_SETTINGS.key,
        CONFIRMATION_PAGE_MODAL.TOC_SETTINGS.value,
      )}
      centered
      visible={visible}
      footer={null}
      width={480}
      style={{ width: '745px' }}
      modalBodyPadding={'0px 34px 34px 34px'}
      ConfirmationPageDialog={true}
      onCancel={onCancel}
      maskClosable={false}
      className="ConfirmationPageModal"
      maskstyle={{ backgroundcolor: 'rgba(0,0,0,0.01)' }}
      transparentCard={false}
    >
      <ModalBody>
        <div className="AddToTocModal">
          <div className="content-wrapper">
            <TocSettings>
              <Radio.Group
                value={tocHeading?.level || ''}
                defaultValue={tocHeading?.level || ''}
                buttonStyle="solid"
                name="level"
              >
                <Radio.Button
                  value={1}
                  name="level"
                  onClick={onChangeText_Level}
                  disabled={tocHeading?.addToc && tocHeading?.level === 1}
                >
                  {t(TOC_SIDEBAR.TITLE.key, TOC_SIDEBAR.TITLE.value)}
                </Radio.Button>
                <Radio.Button
                  value={2}
                  name="level"
                  onClick={onChangeText_Level}
                  disabled={tocHeading?.addToc && tocHeading?.level === 2}
                >
                  {t(TOC_SIDEBAR.SECTION.key, TOC_SIDEBAR.SECTION.value)}
                </Radio.Button>
                <Radio.Button
                  value={3}
                  name="level"
                  onClick={onChangeText_Level}
                  disabled={tocHeading?.addToc && tocHeading?.level === 3}
                >
                  {t(TOC_SIDEBAR.SUB_SECTION.key, TOC_SIDEBAR.SUB_SECTION.value)}
                </Radio.Button>
              </Radio.Group>
              <div className="input-container">
                <Typography>
                  {t(TOC_SIDEBAR.DISPLAY_TEXT.key, TOC_SIDEBAR.DISPLAY_TEXT.value)}
                </Typography>
                <Input
                  placeholder={t(
                    TOC_SIDEBAR.DISPLAY_TEXT_PLACEHOLDER.key,
                    TOC_SIDEBAR.DISPLAY_TEXT_PLACEHOLDER.value,
                  )}
                  defaultValue={tocHeading?.particular || ''}
                  value={tocHeading?.particular}
                  name="particular"
                  autoComplete={false}
                  onChange={onChangeText_Level}
                />
              </div>
              <div className="switch-container">
                <Typography>
                  {t(TOC_SIDEBAR.INCLUDE_IN_TOC.key, TOC_SIDEBAR.INCLUDE_IN_TOC.value)}
                </Typography>
                <Switch
                  checked={tocHeading?.addToc || false}
                  defaultChecked={tocHeading?.addToc || false}
                  onChange={onChangeSwitch}
                />
              </div>

              <HoverAnimationBtn height="55px" onClick={() => updateHeading(tocHeading)}>
                <button data-hover={'submit'}>
                  <div>{'submit'}</div>
                </button>
              </HoverAnimationBtn>
            </TocSettings>
          </div>
        </div>
      </ModalBody>
    </ConfirmationPageModal>
  );
};
export default withTranslation(NAMESPACES)(AddToTocModal);
